import {
    getLatestEdits,
    getLatestEditsFetching,
} from "components/Charts/LatestEdits/LatestEdits.selector";
import { fetchLatestEdits } from "components/Charts/LatestEdits/LatestEdits.service";
import ElementLoader from "components/ElementLoader";
import Widget from "components/Layout/Widget";
import RecordLabel from "components/RecordLabel";
import { TimeAgo } from "components/TimeAgo/TimeAgo";
import { getUserData } from "containers/Auth/Auth.selectors";
import { Resource } from "graphql/generated/graphql";
import { isEmpty } from "lodash";
import { useDispatch, useSelector } from "react-redux";
import { useMount } from "react-use";
import { getRelativeUrl, getTypedLowerCase } from "utils/service";
import "./LatestEdits.scss";

interface LatestEditProps {
    config: any;
    resourceData: any;
    stats: any;
}

export const LatestEdits = ({ config, resourceData, stats }: LatestEditProps) => {
    const dispatch = useDispatch();
    const userData = useSelector(getUserData);
    const latestEdits: Resource[] = useSelector(getLatestEdits);
    const isFetching: boolean = useSelector(getLatestEditsFetching);

    useMount(() => {
        if (!isFetching && !latestEdits.length && !isEmpty(userData)) {
            fetchLatestEdits(dispatch, userData, 5);
        }
    });

    if (isFetching) {
        return <ElementLoader />;
    }

    return (
        <div>
            {latestEdits?.length === 0 && <Widget.Empty />}
            {latestEdits?.map((item) => {
                return (
                    <div className="latestEdits-item" key={item.id}>
                        <TimeAgo
                            className="text-sm text-dark-grey text-bold"
                            datetime={item.modified_at!}
                        />
                        <div className="latestEdits-item__label">
                            <RecordLabel
                                key={`stat${item?.id}`}
                                name={item?.name}
                                link={getRelativeUrl(
                                    getTypedLowerCase(item.resource_type),
                                    item?.id
                                )}
                                iconByType={getTypedLowerCase(item.resource_type)}
                            />
                        </div>
                    </div>
                );
            })}
        </div>
    );
};
